import { SKILL_LABELS, formatLabel, formatModelLabel } from '../workflowShared';
import type { RunToolCard } from './helpers/runScreenTypes';

export const RUN_TOOL_CARDS: RunToolCard[] = [
  {
    id: 'gpt-5-6',
    kind: 'model',
    coverage: 'free',
    title: 'GPT 5.6',
    description: 'Base reasoning model for the free baseline scan.'
  },
  {
    id: 'glm-5-3',
    kind: 'model',
    coverage: 'free',
    title: 'GLM 5.3',
    description: 'Z.ai model that runs alongside GPT 5.6 in the free baseline scan.'
  },
  {
    id: 'trail-of-bits',
    kind: 'skill',
    coverage: 'free',
    title: formatLabel('trail-of-bits', SKILL_LABELS),
    description: 'Security tool coverage for state-changing flows, scanner guidance, and remediation quality.',
    logo: '/trail_of_bits_logo.jpg',
    tag: 'Audit methodology'
  },
  {
    id: 'daybreak-blue',
    kind: 'model',
    coverage: 'deep',
    title: formatModelLabel('gpt-daybreak-blue-latest'),
    description: 'Advanced reasoning model for deeper scan passes and finding synthesis.'
  },
  {
    id: 'claude-opus-5-5',
    kind: 'model',
    coverage: 'deep',
    title: formatModelLabel('claude-opus-5-5'),
    description: 'Independent model pass for broader reasoning coverage.'
  },
  {
    id: 'pashov',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('pashov', SKILL_LABELS),
    description: 'Fast smart-contract review workflow focused on realistic exploit paths and high-signal findings.',
    logo: '/pashovlogo.png',
    tag: 'Audit workflow'
  },
  {
    id: 'sc-auditor',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('sc-auditor', SKILL_LABELS),
    description: 'Map-Hunt-Attack style smart-contract review for entry points, invariants, and attack surfaces.',
    tag: 'Attack review'
  },
  {
    id: 'quillshield',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('quillshield', SKILL_LABELS),
    description: 'Semantic state review across invariants, reentrancy, oracle manipulation, upgrades, and griefing.',
    logo: '/quillshield.avif',
    tag: 'State analysis'
  },
  {
    id: 'cyfrin',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('cyfrin', SKILL_LABELS),
    description: 'Production-grade Solidity standards, Foundry workflow review, testing quality, and secure patterns.',
    logo: '/cyfrin.jpg',
    tag: 'Solidity review'
  },
  {
    id: 'forefy',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('forefy', SKILL_LABELS),
    description: 'Protocol-type detection, threat modeling, severity calibration, and report-oriented audit structure.',
    tag: 'Threat model'
  },
  {
    id: 'trail-of-bits-supply-chain',
    kind: 'skill',
    coverage: 'deep',
    title: 'Trail of Bits Supply Chain',
    description: 'Dependency takeover and package risk assessment for web application and API source workspaces.',
    logo: '/trail_of_bits_logo.jpg',
    tag: 'Supply chain'
  },
  {
    id: 'trail-of-bits-static-analysis',
    kind: 'skill',
    coverage: 'deep',
    title: 'Trail of Bits Static Analysis',
    description: 'CodeQL, Semgrep, and SARIF-guided review for source-assisted web and API security analysis.',
    logo: '/trail_of_bits_logo.jpg',
    tag: 'Static analysis'
  },
  {
    id: 'semgrep-code-security',
    kind: 'skill',
    coverage: 'deep',
    title: formatLabel('semgrep-code-security', SKILL_LABELS),
    description: 'Pattern and taint-style review for injection, SSRF, path traversal, secrets, and unsafe configuration.',
    tag: 'Code security'
  }
];
